/*
These functions make sure WordPress
and Foundation play nice together.
*/

jQuery(document).ready(function() {

	var HeightLeft = jQuery('.main-house-item').outerHeight();
	if ( HeightLeft > 700 && jQuery('.main-house-information').length == 0 ){
		jQuery('.main-house > .grid-container > .grid-x').addClass('align-top');
	}else if( jQuery('.main-house-information').length > 0 ){
		jQuery('.main-house > .grid-container > .grid-x').addClass('align-top');
	}

	jQuery(".burger-menu").click(function () {
		jQuery(this).toggleClass("menu-on");
	});

	jQuery('.houses-row .houses-row-content .btn-large').each(function(index, el) {
		var CutString = jQuery(this).text();
		CutString = CutString.substring(0, CutString.indexOf('–'));
		jQuery(this).text(CutString);
	});

	jQuery('.burger-menu').on('click',function(){

		jQuery('.menu-fullscreen').fadeToggle();
		jQuery('html').toggleClass('menu-active');
		jQuery('header.header').toggleClass('header-active');

	});


	jQuery('.brands-slider').slick({
		dots: false,
		arrows: false,
		autoplay: true,
		autoplaySpeed: 5000,
		infinite: true,
		speed: 300,
		slidesToShow: 5,
		slidesToScroll: 1,
		responsive: [
		{
			breakpoint: 1024,
			settings: {
				slidesToShow: 3,
				slidesToScroll: 3,
			}
		},
		{
			breakpoint: 600,
			settings: {
				slidesToShow: 2,
				slidesToScroll: 2
			}
		},
		]
	});

	jQuery('.building-gallery-slider').slick({
		dots: true,
		arrows: false,
		infinite: true,
		speed: 500,
		fade: true,
		cssEase: 'linear',
	});

	jQuery('.meeting-js').on('click',function() {

		var title = jQuery(this).parent().find('.meeting-title').text();

		jQuery('#input_1_3 option, #input_2_1 option').filter(function() {
			return (jQuery(this).text() == title );
		}).prop('selected', true);

	});


	// Remove empty P tags created by WP inside of Accordion and Orbit
	jQuery('.accordion p:empty, .orbit p:empty').remove();

	// Adds Flex Video to YouTube and Vimeo Embeds
	jQuery('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
		if ( jQuery(this).innerWidth() / jQuery(this).innerHeight() > 1.5 ) {
			jQuery(this).wrap("<div class='widescreen responsive-embed'/>");
		} else {
			jQuery(this).wrap("<div class='responsive-embed'/>");
		}
	});

	jQuery('.reviews-slider').slick({
		dots: false,
		arrows: false,
		infinite: true,
		speed: 500,
		fade: true,
		cssEase: 'linear',
		autoplay: true,
		autoplaySpeed: 5000,
	});

	var status = jQuery('#pagingInfo-home');
	var slickElement = jQuery('.hero-slider');


	slickElement.on('init reInit afterChange', function(event, slick, currentSlide, nextSlide){
		var i = (currentSlide ? currentSlide : 0) + 1;
		if( slick.slideCount < 10 ){
			status.text('0' + i + ' / 0' + slick.slideCount);
		}else{
			status.text(i + ' / ' + slick.slideCount);
		}
	});

	slickElement.slick({
		dots: false,
		infinite: true,
		speed: 500,
		fade: true,
		cssEase: 'linear',
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplaySpeed: 5000,
		autoplay: false,
		arrows: true,
		appendArrows: jQuery('#hero-slider-information'),
		prevArrow:"<span class='prev-arr'></span>",
		nextArrow:"<span class='next-arr'></span>"
	});

	var numSlick = 0;
	jQuery('.houses-row').each(function() {
		numSlick++;
		var status = jQuery(this).find('.pagingInfo');
		var slickElement = jQuery(this).find('.houses-row-slider').addClass( 'houses-row-slider' + numSlick );


		slickElement.on('init reInit afterChange', function(event, slick, currentSlide, nextSlide){
			var i = (currentSlide ? currentSlide : 0) + 1;
			if( slick.slideCount < 10 ){
				status.text('0' + i + ' / 0' + slick.slideCount);
			}else{
				status.text(i + ' / ' + slick.slideCount);
			}
		});
		slickElement.slick({
			dots: false,
			infinite: true,
			speed: 500,
			fade: true,
			cssEase: 'linear',
			slidesToShow: 1,
			arrows: true,
			appendArrows: jQuery(this).find('.hero-slider-information'),
			prevArrow:"<span class='prev-arr'></span>",
			nextArrow:"<span class='next-arr'></span>"
		});
		var dataTitle = slickElement.find('.slick-active').data('title');
		slickElement.parent().find('.houses-row-slider-title p').text(dataTitle);

		slickElement.on('afterChange', function(event, slick, currentSlide, nextSlide){
			var dataTitle = jQuery(this).find('.slick-active').data('title');

			slickElement.parent().find('.houses-row-slider-title p').text(dataTitle);
		});


	});

	jQuery(document).on('open.zf.reveal', '[data-reveal]', function (event) {
	 jQuery(this).find('video')[0].play();
	});
	jQuery(document).on('closed.zf.reveal', '[data-reveal]', function(event) {
		jQuery(this).find('video')[0].pause();
	});


	var tag = document.createElement('script');
	tag.src = "http://www.youtube.com/player_api";
	var firstScriptTag = document.getElementsByTagName('script')[0];
	firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

        function onYouTubePlayerAPIReady() { //Important to set up the the modal inside this function, not the other way around
        	jQuery('.feature-modal-btn').on('click', function(e){
        		e.preventDefault();
        		var btn = jQuery(this);
        		var modal = btn.attr('href');
        		var ytVideoID = btn.data('ytvideoid');

        		var player;

        		jQuery(modal).reveal({
        			animation: 'fade',
                    opened: function() { //After the modal is done opening
                        player = new YT.Player('feature-video', { //Add the player
                        	height: '315',
                        	width: '560',
                          videoId: ytVideoID //ytVideoID is the variable that holds my youtube video ID
                      });
                    },
                    close: function() { //When closing the modal is initiated
                        jQuery('#feature-video').remove(); //Remove the iframe
                        jQuery(modal).append('<div id="feature-video" />'); //Add the div again for next time
                    }
                });
        	});
        }




    });
